export default {
  employee: "employee",
  corporation: "corporation",
  admin: "admin"
};
